import React, {useState } from 'react'
import { Button, Input, Spin, } from 'antd'
import 'aos/dist/aos.css'
import '../MainCSS.css'
import axios from 'axios'
import { toast } from 'react-toastify'
import { BaseIPForPDF } from '../../AllAPI/CommonAPI/CommonApi'
import { GetSalesItemWiseReportData } from '../../AllAPI/SalesOrderReportAPI/SalesOrderReportApi'

const SalesItemWiseReport = () => {

   const commonHeaders1 = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
    },
  }

   const [errors, setErrors] = useState({
      fromOrderNo: '',
      toOrderNo: '',
    })

    const [fromOrderNo, setFromOrderNo] = useState('')
    const [toOrderNo, setToOrderNo] = useState('')
     const [loading, setLoading] = useState(false)

     //=========CANCEL SALES ITEM WISE REPORT DATA============
  const handleCancel = () => {
    setFromOrderNo('')
    setToOrderNo('')
    setErrors('')
  }

  //=========GET SALES ITEM WISE REPORT DATA============
    const handleShowPdf = async () => {
    let isValid = true
    const errorObj = {}

     if (!fromOrderNo) {
      isValid = false;
      errorObj.fromOrderNo = "From Order is required *";
    }
     if (!toOrderNo) {
      isValid = false;
      errorObj.toOrderNo = "To Order is required *";
    }

    setErrors(errorObj)
    if (!isValid) return


    try {
      const response = await axios.get(`${GetSalesItemWiseReportData}?orderNumberIdFrom=${fromOrderNo}&orderNumberIdTo=${toOrderNo}`, commonHeaders1)

      if (response.data !== null) {
        if (
          response.data === 'NOTFOUND' ||
          response.data === 'NODATA' ||
          response.status === 204
        ) {
          toast.warn('No data available!', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })

          setLoading(false)
          return // Exit function early
        }
  
        let reportUrl = response.data
        if (reportUrl === 'NOTFOUND') {
          toast.warn('Report File Not Found...!!', {
            position: 'top-right',
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
        } else {
          const reportLink = BaseIPForPDF + `output/${reportUrl}`
          window.open(reportLink, '_blank')
        }
      }
    } catch (error) {
      setLoading(false)
      console.error('Error during API call:', error)
      toast.error('Error occurred while submitting data')
    }
    }


  return (
    <>
      <div className="px-5 py-3">
        <div
          className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded"
          style={{ backgroundColor: '#e0efff' }}
        >
          <div className="col-12">
            <div className="row px-md-5 mt-3 p-2">
                <div className="col-md-6 col-lg-3 py-1"></div>
                <div className="col-md-6 col-lg-3 py-1">
                  <label className="labels">From Order No.</label>
                  <Input type="number"
                    value={fromOrderNo}
                    onChange={(e) => setFromOrderNo(e.target.value)}
                    placeholder="Enter No."
                    maxLength={250}
                  />
                   {errors.fromOrderNo && (
                      <div className="errorField">{errors.fromOrderNo}</div>
                    )}
                </div>
                <div className="col-md-6 col-lg-3 py-1">
                  <label className="labels">To Order No.</label>
                  <Input type="number"
                    value={toOrderNo}
                    onChange={(e) => setToOrderNo(e.target.value)}
                    placeholder="Enter No."
                    maxLength={250}
                  />
                   {errors.toOrderNo && (
                      <div className="errorField">{errors.toOrderNo}</div>
                    )}
                </div>
                <div className="col-md-6 col-lg-3 py-1"></div>

                <div className="col-12 text-center pt-3">
                  <Button
                    type="submit"
                    className="CancelBtn mx-1"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    className="SubmitBtn mx-1"
                    onClick={handleShowPdf}
                    disabled={loading}
                  >
                      {loading ? "Generating PDF..." : "View Report"}
                  </Button>
 
                </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default SalesItemWiseReport
